import { fields } from "./fields";

export const filtersElements = [
  {
    value: fields.PERIOD_FIlTER_FROM,
    title: "Период",
  },
];
